import { render, staticRenderFns } from "./itemsComponent.vue?vue&type=template&id=eec8a206&scoped=true&"
import script from "./itemsComponent.vue?vue&type=script&lang=js&"
export * from "./itemsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec8a206",
  null
  
)

export default component.exports